// extracted by mini-css-extract-plugin
export var closeButton = "_g2-1";
export var closeX = "_g2-3";
export var container = "_g2-0";
export var image = "_g2-2";